import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { getCupons } from "../../../../services/modules/cliente/clienteService";
import ModalCupomAdmin from "./modalCupom";
import { Button } from "@mui/material";

export default function CupomPageADMIN() {
  const [data, setData] = useState<any>();
  const [err, setErr] = useState();
  const [selectedCupom, setSelectedCupom] = useState(null);
  const tableRef = useRef(null);

  useEffect(() => {
    getCupons().then(data => setData(data.dados)).catch(err => {
      setErr(err?.message || "Erro ao carregar os dados.");
    });
  }, []);

  const handleRowClick = (cupom) => {
    setSelectedCupom(cupom);
  }

  const onClose = () => {
    setSelectedCupom(null);
  }

  const onAdd = () => {
    setSelectedCupom({});
  }

  return (
    <section>
      <Container>
        <Title>Cupom de Desconto</Title>
        {err && (
          <p className="text-center">
            Dados não disponíveis!
            <br />
            {err}
          </p>
        )}
        <Button
          variant="contained"
          color="primary"
          onClick={onAdd}
          style={{ marginBottom: "20px" }}
        >
          Adicionar Cupom
        </Button>
        {data && (
            <table className="table table-hover table-bordered" ref={tableRef}>
              <thead>
                <tr>
                  <th scope="col">Código do Cupom</th>
                  <th className="text-center" scope="col">
                    Descrição
                  </th>
                  <th className="text-center" scope="col">
                    Valor do desconto
                  </th>
                  <th className="" scope="col">
                    Valor Mínimo de Compra
                  </th>
                  <th>Função</th>
                </tr>
              </thead>
              <tbody>
                {data?.map((item, i) => {
                  return (
                    <tr key={i++}>
                      <td>{item.codigo_cupom}</td>
                      <td>
                        {item.descricao}
                      </td>
                      <td>{item.valor_desconto}</td>
                      <td>{item.valor_minimo_compra}</td>
                      <td><Button fullWidth onClick={() => handleRowClick(item)}>Editar</Button></td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
        )}

        {selectedCupom && <ModalCupomAdmin cupom={selectedCupom} onClose={onClose} />}
      </Container>
    </section>
  );
}

const Container = styled.div`
  width: 100%;
  padding: 60px 100px;
`;
const Title = styled.h1`
  width: 100%;
  text-align: center;
  margin-bottom: 50px;
`;
